
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.2 2.054a.751.751 0 0 0-.748-.8H1.5a.75.75 0 0 0-.748.8 11.254 11.254 0 0 0 8.972 10.22v9.875a.75.75 0 0 0 1.23.576l3-2.5a.748.748 0 0 0 .27-.576v-7.375A11.253 11.253 0 0 0 23.2 2.054Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    